import React from "react";
import { ListVideo } from "lucide-react";
import TableBodyCustom from "./table.body-custom";
import DataTable from "../../../../components/data-table/DataTable";

const TABLE_HEAD = [
  { id: "name", label: "Name" },
  { id: "color/theme", label: "Colour / theme" },
  { id: "active", label: "Status" },
  { id: "action", label: "" },
];

// searching: a search is on, so "empty" means nothing matched.
const TableView = ({ eventsData, onEditRow, searching, }) => (
  <DataTable
    head={TABLE_HEAD}
    isEmpty={!eventsData?.length}
    empty={
      searching
        ? { title: "Nothing matches your search", text: "Try a different word, or clear the search." }
        : {
            icon: ListVideo,
            title: "No playlists yet",
            text: "A playlist sets what a screen shows and in which order.",
          }
    }
  >
    {eventsData?.map((data) => (
      <TableBodyCustom key={data?._id} data={data} onEditRow={onEditRow} />
    ))}
  </DataTable>
);

export default TableView;
